import React from 'react';
import { AlertCircle } from 'lucide-react';

export function FieldError({ id, message }) {
  if (!message) return null;
  return (
    <p id={id} role="alert" className="flex items-center gap-1 text-xs text-red-600 mt-1" data-testid={id}>
      <AlertCircle className="w-3.5 h-3.5 flex-shrink-0" /> {message}
    </p>
  );
}

export function ErrorSummary({ errors, testId }) {
  const messages = Object.values(errors || {}).filter(Boolean);
  if (!messages.length) return null;
  return (
    <div role="alert" className="rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-700" data-testid={testId}>
      <p className="font-medium mb-1">Please fix {messages.length === 1 ? 'this' : `these ${messages.length} items`} to continue:</p>
      <ul className="list-disc pl-5 space-y-0.5">
        {messages.map((m) => <li key={m}>{m}</li>)}
      </ul>
    </div>
  );
}

export const errorClass = (msg) => (msg ? 'border-red-500 focus-visible:ring-red-500' : '');
